import CompletedMeasurements
 from './CompletedMeasurements';

export default CompletedMeasurements
;